// @flow
/* eslint-disable css-modules/no-unused-class */

import * as React from 'react';
import { featureIsEnabled } from '@ta/common.features';
import { QueriedTripFlowSelector } from '@ta/trips.trip-flow-selector';
import { BookmarkIcon, type BookmarkSize, type BookmarkTextStyle } from '@ta/trips.bookmark-icon';
import * as TripTypes from '@ta/trips.trip-types';

import styles from './SaveAction.less';
import socialStyles from './SocialAction.less';

type Props = {
  object: any,
  displayStyle: 'icon' | 'icon+text',
  bookmarkSize?: BookmarkSize,
  onClick?: () => void,
  preventInteractionPropagation?: boolean,
  bookmarkTextStyle?: BookmarkTextStyle,
  trip?: TripTypes.Trip,
};

const SaveAction = ({
  object,
  displayStyle,
  bookmarkSize,
  onClick,
  preventInteractionPropagation,
  bookmarkTextStyle,
  trip,
}: Props) => (
  <div className={`${socialStyles.social_action} ${styles.save_icon}`}>
    <QueriedTripFlowSelector
      object={object}
      preventInteractionPropagation={preventInteractionPropagation}
      trip={trip}
    >
      {(openFlow, active) => (
        <BookmarkIcon
          active={active}
          bookmarkStyle="flat"
          bookmarkSize={bookmarkSize || (featureIsEnabled('trips_saves_heart') ? '20' : '18')}
          lineHeight={20}
          bookmarkTextStyle={bookmarkTextStyle}
          onClick={() => {
            if (onClick) {
              onClick();
            }
            openFlow();
          }}
        >
          {text => (displayStyle.includes('text') ? text : '')}
        </BookmarkIcon>
      )}
    </QueriedTripFlowSelector>
  </div>
);

SaveAction.defaultProps = {
  onClick: undefined,
  preventInteractionPropagation: false,
  placement: undefined,
};

export default SaveAction;
